import { render, staticRenderFns } from "./adminProspect.vue?vue&type=template&id=9bf224ac&scoped=true"
import script from "./adminProspect.vue?vue&type=script&lang=js"
export * from "./adminProspect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf224ac",
  null
  
)

export default component.exports